/** Shared paths for the Enrollment PDF Generator under Practice Enrollments. */
export const ENROLLMENT_PDF_LIST_PATH = '/dashboard/practices/enrollments';
export const ENROLLMENT_PDF_TAB = 'enrollment-pdfs';

export const ENROLLMENT_PDF_TAB_HREF = `${ENROLLMENT_PDF_LIST_PATH}?tab=${ENROLLMENT_PDF_TAB}`;
export const ENROLLMENT_PDF_RUN_BASE = `${ENROLLMENT_PDF_LIST_PATH}/pdf`;

export function enrollmentPdfListHref(): string {
  return ENROLLMENT_PDF_TAB_HREF;
}

export function enrollmentPdfRunPath(runId: string): string {
  return `${ENROLLMENT_PDF_RUN_BASE}/${runId}`;
}
